import React from "react";
import {Box, makeStyles} from "@material-ui/core";
import {AllInbox, CheckCircle, Description, DirectionsBike, Error, LocalShipping, Warning} from "@material-ui/icons";
import {useTranslation} from "react-i18next";
import {DeliveryCsvAnalysisAggregatedResult} from "api/deliveryCsvAnalysis";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
    gap: "24px",
    alignItems: "center",
    padding: "12px 0",
  },
  stat: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  icon: {
    fontSize: "18px",
  },
  successIcon: {
    color: "#4caf50",
  },
  warningIcon: {
    color: "#ff9800",
  },
  errorIcon: {
    color: "#f44336",
  },
  infoIcon: {
    color: "#2196f3",
  },
  value: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#353945",
  },
  label: {
    fontSize: "13px",
    color: "#666",
  },
}));

interface AnalysisSummaryCardsProps {
  result: DeliveryCsvAnalysisAggregatedResult;
}

export const AnalysisSummaryCards = (props: AnalysisSummaryCardsProps) => {
  const { result } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  const stats = [
    {
      icon: <Description className={`${classes.icon} ${classes.infoIcon}`} />,
      value: result.totalFiles,
      label: t("received_data_analysis_total_files"),
    },
    {
      icon: <DirectionsBike className={`${classes.icon} ${classes.infoIcon}`} />,
      value: result.totalTours,
      label: t("received_data_analysis_total_tours"),
    },
    {
      icon: <LocalShipping className={`${classes.icon} ${classes.infoIcon}`} />,
      value: result.totalDeliveries.toLocaleString(),
      label: t("received_data_analysis_total_deliveries"),
    },
    {
      icon: <AllInbox className={`${classes.icon} ${classes.infoIcon}`} />,
      value: result.totalPackages.toLocaleString(),
      label: t("received_data_analysis_total_packages"),
    },
    {
      icon: <CheckCircle className={`${classes.icon} ${classes.successIcon}`} />,
      value: result.successCount,
      label: t("received_data_analysis_success_count"),
    },
    {
      icon: <Warning className={`${classes.icon} ${classes.warningIcon}`} />,
      value: result.warningCount,
      label: t("received_data_analysis_warning_count"),
    },
    {
      icon: <Error className={`${classes.icon} ${classes.errorIcon}`} />,
      value: result.errorCount,
      label: t("received_data_analysis_error_count"),
    },
  ];

  return (
    <Box className={classes.container}>
      {stats.map((stat, index) => (
        <Box key={index} className={classes.stat}>
          {stat.icon}
          <span className={classes.value}>{stat.value}</span>
          <span className={classes.label}>{stat.label}</span>
        </Box>
      ))}
    </Box>
  );
};
